(function () {
  var MESSAGES = {
    succes: 'C’est bon, direction votre panier…',
    echec: 'L’ajout au panier n’a pas abouti. Réessayez dans un instant, ou écrivez-nous à abonnement@views.fr.',
    refus: 'L’abonnement n’est pas disponible pour le moment. Réessayez dans un instant, ou écrivez-nous à abonnement@views.fr.',
    seul: 'L’abonnement se commande seul. Terminez ou videz votre panier, puis revenez vous abonner.',
    lien: 'Pas d’adresse web dans le cadeau : retirez-la de « {champ} » pour continuer.',
    invisible: '« {champ} » contient un caractère invisible ou de contrôle : retapez le texte pour continuer.',
    nom: '« {champ} » n’accepte que des lettres, des espaces, des apostrophes, des traits d’union et des points d’initiale.'
  };

  var LECTURE_MAX_MS = 3000;

  var CHAMPS_CADEAU = [
    ['[data-vw-abo-pour]', 'Son prénom et son nom', 60],
    ['[data-vw-abo-de]', 'De la part de', 40],
    ['[data-vw-abo-message-carte]', 'Votre message', 0]
  ];
  var LIEN = /(?:https?:|ftp:|mailto:|www\.)/i;
  var DOMAINE = /[^\s.]\.([\p{L}\p{M}\p{N}-]{2,})/gu;
  var IGNORABLES = /\p{Default_Ignorable_Code_Point}/gu;
  var SUFFIXES = new Set('aaa aarp abb abbott abbvie abc able abogado abudhabi ac academy accenture accountant accountants aco actor ad ads adult ae aeg aero aetna af afl africa ag agakhan agency ai aig airbus airforce airtel akdn al alibaba alipay allfinanz allstate ally alsace alstom am amazon americanexpress americanfamily amex amfam amica amsterdam analytics android anquan anz ao aol apartments app apple aq aquarelle ar arab aramco archi army arpa art arte as asda asia associates at athleta attorney au auction audi audible audio auspost author auto autos aw aws ax axa az azure ba baby baidu banamex band bank bar barcelona barclaycard barclays barefoot bargains baseball basketball bauhaus bayern bb bbc bbt bbva bcg bcn bd be beats beauty beer berlin best bestbuy bet bf bg bh bharti bi bible bid bike bing bingo bio biz bj black blackfriday blockbuster blog bloomberg blue bm bms bmw bn bnpparibas bo boats boehringer bofa bom bond boo book booking bosch bostik boston bot boutique box br bradesco bridgestone broadway broker brother brussels bs bt build builders business buy buzz bv bw by bz bzh ca cab cafe cal call calvinklein cam camera camp canon capetown capital capitalone car caravan cards care career careers cars casa case cash casino cat catering catholic cba cbn cbre cc cd center ceo cern cf cfa cfd cg ch chanel channel charity chase chat cheap chintai christmas chrome church ci cipriani circle cisco citadel citi citic city ck cl claims cleaning click clinic clinique clothing cloud club clubmed cm cn co coach codes coffee college cologne com commbank community company compare computer comsec condos construction consulting contact contractors cooking cool coop corsica country coupon coupons courses cpa cr credit creditcard creditunion cricket crown crs cruise cruises cu cuisinella cv cw cx cy cymru cyou cz dad dance data date dating datsun day dclk dds de deal dealer deals degree delivery dell deloitte delta democrat dental dentist desi design dev dhl diamonds diet digital direct directory discount discover dish diy dj dk dm dnp do docs doctor dog domains dot download drive dtv dubai dupont durban dvag dvr dz earth eat ec eco edeka edu education ee eg email emerck energy engineer engineering enterprises epson equipment er ericsson erni es esq estate et eu eurovision eus events exchange expert exposed express extraspace fage fail fairwinds faith family fan fans farm farmers fashion fast fedex feedback ferrari ferrero fi fidelity fido film final finance financial fire firestone firmdale fish fishing fit fitness fj fk flickr flights flir florist flowers fly fm fo foo food football ford forex forsale forum foundation fox fr free fresenius frl frogans frontier ftr fujitsu fun fund furniture futbol fyi ga gal gallery gallo gallup game games gap garden gay gb gbiz gd gdn ge gea gent genting george gf gg ggee gh gi gift gifts gives giving gl glass gle global globo gm gmail gmbh gmo gmx gn godaddy gold goldpoint golf goodyear goog google gop got gov gp gq gr grainger graphics gratis green gripe grocery group gs gt gu gucci guge guide guitars guru gw gy hair hamburg hangout haus hbo hdfc hdfcbank health healthcare help helsinki here hermes hiphop hisamitsu hitachi hiv hk hkt hm hn hockey holdings holiday homedepot homegoods homes homesense honda horse hospital host hosting hot hotels hotmail house how hr hsbc ht hu hughes hyatt hyundai ibm icbc ice icu id ie ieee ifm ikano il im imamat imdb immo immobilien in inc industries infiniti info ing ink institute insurance insure int international intuit investments io ipiranga iq ir irish is ismaili ist istanbul it itau itv jaguar java jcb je jeep jetzt jewelry jio jll jm jmp jnj jo jobs joburg jot joy jp jpmorgan jprs juegos kaufen kddi ke kerryhotels kerryproperties kfh kg kh ki kia kids kim kindle kitchen kiwi km kn koeln komatsu kosher kp kpmg kpn kr krd kred kuokgroup kw ky kyoto kz la lacaixa lamborghini lamer land landrover lanxess lasalle lat latino latrobe law lawyer lb lc lds lease leclerc lefrak legal lego lexus lgbt li lidl life lifeinsurance lifestyle lighting like lilly limited limo lincoln link live living lk llc llp loan loans locker locus lol london lotte lotto love lpl lplfinancial lr ls lt ltd ltda lu lundbeck luxe luxury lv ly ma madrid maif maison makeup man management mango map market marketing markets marriott marshalls mattel mba mc mckinsey md me med media meet melbourne meme memorial men menu merck merckmsd mg mh miami microsoft mil mini mint mit mitsubishi mk ml mlb mls mm mma mn mo mobi mobile moda moe moi mom monash money monster mormon mortgage moscow moto motorcycles mov movie mp mq mr ms msd mt mtn mtr mu museum music mv mw mx my mz na nab nagoya name navy nba nc ne nec net netbank netflix network neustar new news next nextdirect nexus nf nfl ng ngo nhk ni nico nike nikon ninja nissan nissay nl no nokia norton now nowruz nowtv np nr nra nrw ntt nu nyc nz obi observer office okinawa olayan olayangroup ollo om omega one ong onl online ooo open oracle orange org organic origins osaka otsuka ott ovh pa page panasonic paris pars partners parts party pay pccw pe pet pf pfizer pg ph pharmacy phd philips phone photo photography photos physio pics pictet pictures pid pin ping pink pioneer pizza pk pl place play playstation plumbing plus pm pn pnc pohl poker politie porn post pr praxi press prime pro prod productions prof progressive promo properties property protection pru prudential ps pt pub pw pwc py qa qpon quebec quest racing radio re read realestate realtor realty recipes red redumbrella rehab reise reisen reit reliance ren rent rentals repair report republican rest restaurant review reviews rexroth rich richardli ricoh ril rio rip ro rocks rodeo rogers room rs rsvp ru rugby ruhr run rw rwe ryukyu sa saarland safe safety sakura sale salon samsclub samsung sandvik sandvikcoromant sanofi sap sarl sas save saxo sb sbi sbs sc scb schaeffler schmidt scholarships school schule schwarz science scot sd se search seat secure security seek select sener services seven sew sex sexy sfr sg sh shangrila sharp shell shia shiksha shoes shop shopping shouji show si silk sina singles site sj sk ski skin sky skype sl sling sm smart smile sn sncf so soccer social softbank software sohu solar solutions song sony soy spa space sport spot sr srl ss st stada staples star statebank statefarm stc stcgroup stockholm storage store stream studio study style su sucks supplies supply support surf surgery suzuki sv swatch swiss sx sy sydney systems sz tab taipei talk taobao target tatamotors tatar tattoo tax taxi tc tci td tdk team tech technology tel temasek tennis teva tf tg th thd theater theatre tiaa tickets tienda tips tires tirol tj tjmaxx tjx tk tkmaxx tl tm tmall tn to today tokyo tools top toray toshiba total tours town toyota toys tr trade trading training travel travelers travelersinsurance trust trv tt tube tui tunes tushu tv tvs tw tz ua ubank ubs ug uk unicom university uno uol ups us uy uz va vacations vana vanguard vc ve vegas ventures verisign vermögensberater vermögensberatung versicherung vet vg vi viajes video vig viking villas vin vip virgin visa vision viva vivo vlaanderen vn vodka volvo vote voting voto voyage vu wales walmart walter wang wanggou watch watches weather weatherchannel web webcam weber website wed wedding weibo weir wf whoswho wien wiki williamhill win windows wine winners wme woodside work works world wow ws wtc wtf xbox xerox xihuan xin xn--11b4c3d xn--1ck2e1b xn--1qqw23a xn--2scrj9c xn--30rr7y xn--3bst00m xn--3ds443g xn--3e0b707e xn--3hcrj9c xn--3pxu8k xn--42c2d9a xn--45br5cyl xn--45brj9c xn--45q11c xn--4dbrk0ce xn--4gbrim xn--54b7fta0cc xn--55qw42g xn--55qx5d xn--5su34j936bgsg xn--5tzm5g xn--6frz82g xn--6qq986b3xl xn--80adxhks xn--80ao21a xn--80aqecdr1a xn--80asehdb xn--80aswg xn--8y0a063a xn--90a3ac xn--90ae xn--90ais xn--9dbq2a xn--9et52u xn--9krt00a xn--b4w605ferd xn--bck1b9a5dre4c xn--c1avg xn--c2br7g xn--cck2b3b xn--cckwcxetd xn--cg4bki xn--clchc0ea0b2g2a9gcd xn--czr694b xn--czrs0t xn--czru2d xn--d1acj3b xn--d1alf xn--e1a4c xn--eckvdtc9d xn--efvy88h xn--fct429k xn--fhbei xn--fiq228c5hs xn--fiq64b xn--fiqs8s xn--fiqz9s xn--fjq720a xn--flw351e xn--fpcrj9c3d xn--fzc2c9e2c xn--fzys8d69uvgm xn--g2xx48c xn--gckr3f0f xn--gecrj9c xn--gk3at1e xn--h2breg3eve xn--h2brj9c xn--h2brj9c8c xn--hxt814e xn--i1b6b1a6a2e xn--imr513n xn--io0a7i xn--j1aef xn--j1amh xn--j6w193g xn--jlq480n2rg xn--jvr189m xn--kcrx77d1x4a xn--kprw13d xn--kpry57d xn--kput3i xn--l1acc xn--lgbbat1ad8j xn--mgb9awbf xn--mgba3a3ejt xn--mgba3a4f16a xn--mgba7c0bbn0a xn--mgbaam7a8h xn--mgbab2bd xn--mgbah1a3hjkrd xn--mgbai9azgqp6j xn--mgbayh7gpa xn--mgbbh1a xn--mgbbh1a71e xn--mgbc0a9azcg xn--mgbca7dzdo xn--mgbcpq6gpa1a xn--mgberp4a5d4ar xn--mgbgu82a xn--mgbi4ecexp xn--mgbpl2fh xn--mgbt3dhd xn--mgbtx2b xn--mgbx4cd0ab xn--mix891f xn--mk1bu44c xn--mxtq1m xn--ngbc5azd xn--ngbe9e0a xn--ngbrx xn--node xn--nqv7f xn--nqv7fs00ema xn--nyqy26a xn--o3cw4h xn--ogbpf8fl xn--otu796d xn--p1acf xn--p1ai xn--pgbs0dh xn--pssy2u xn--q7ce6a xn--q9jyb4c xn--qcka1pmc xn--qxa6a xn--qxam xn--rhqv96g xn--rovu88b xn--rvc1e0am3e xn--s9brj9c xn--ses554g xn--t60b56a xn--tckwe xn--tiq49xqyj xn--unup4y xn--vermgensberater-ctb xn--vermgensberatung-pwb xn--vhquv xn--vuq861b xn--w4r85el8fhu5dnra xn--w4rs40l xn--wgbh1c xn--wgbl6a xn--xhq521b xn--xkc2al3hye2a xn--xkc2dl3a5ee0h xn--y9a3aq xn--yfro4i67o xn--ygbi2ammx xn--zfr164b xxx xyz yachts yahoo yamaxun yandex ye yodobashi yoga yokohama you youtube yt yun za zappos zara zero zip zm zone zuerich zw ελ ευ бг бел дети ею католик ком мкд мон москва онлайн орг рус рф сайт срб укр қаз հայ ישראל קום ابوظبي ارامكو الاردن البحرين الجزائر السعودية العليان المغرب امارات ایران بارت بازار بيتك بھارت تونس سودان سورية شبكة عراق عرب عمان فلسطين قطر كاثوليك كوم مصر مليسيا موريتانيا موقع همراه پاکستان ڀارت कॉम नेट भारत भारतम् भारोत संगठन বাংলা ভারত ভাৰত ਭਾਰਤ ભારત ଭାରତ இந்தியா இலங்கை சிங்கப்பூர் భారత్ ಭಾರತ ഭാരതം ලංකා คอม ไทย ລາວ გე みんな アマゾン クラウド グーグル コム ストア セール ファッション ポイント 世界 中信 中国 中國 中文网 亚马逊 企业 佛山 信息 健康 八卦 公司 公益 台湾 台灣 商城 商店 商标 嘉里 嘉里大酒店 在线 大拿 天主教 娱乐 家電 广东 微博 慈善 我爱你 手机 招聘 政务 政府 新加坡 新闻 时尚 書籍 机构 淡马锡 游戏 澳門 点看 移动 组织机构 网址 网店 网站 网络 联通 谷歌 购物 通販 集团 電訊盈科 飞利浦 食品 餐厅 香格里拉 香港 닷넷 닷컴 삼성 한국'.split(' '));
  var POINTS = /[\u3002\uFF0E\uFF61\u2024\uFE52]/g;
  var INVISIBLE = /[\u0000-\u0008\u000B\u000C\u000E-\u001F\u007F-\u009F\u00AD\u034F\u061C\u115F\u1160\u17B4\u17B5\u180B-\u180F\u200B\u200C\u200E\u200F\u2028-\u202E\u2060-\u2064\u2066-\u206F\u3164\uFE00-\uFE0E\uFEFF\uFFA0\uFFF9-\uFFFB]/;
  var PICTO = /\p{Extended_Pictographic}/u;
  var MODIFIEUR = /\uFE0F|[\u{1F3FB}-\u{1F3FF}]/u;
  var NOM_CONTROLE = /[\u0000-\u001F\u007F-\u009F\u2028\u2029\u200B-\u200F\u202A-\u202E\u2060-\u2064\uFEFF]/;
  var NOM_IGNORABLE = /\p{Default_Ignorable_Code_Point}/u;
  var NOM = /^\p{L}[\p{L}'\u2019 .-]*$/u;
  var POINT_HORS_ABREVIATION = /\.(?![ -]|$)/;

  function joncteurIsole(v) {
    var c = Array.from(v);
    for (var i = 0; i < c.length; i++) {
      if (c[i] !== '\u200D') continue;
      var j = i - 1;
      while (j >= 0 && MODIFIEUR.test(c[j])) j--;
      if (j < 0 || !PICTO.test(c[j]) || i + 1 >= c.length || !PICTO.test(c[i + 1])) return true;
    }
    return false;
  }

  function fauteCadeau(v, longueurNom) {
    if (INVISIBLE.test(v) || joncteurIsole(v)) return MESSAGES.invisible;
    if (longueurNom) return fauteNom(v, longueurNom);
    return lienDans(pourLien(v)) ? MESSAGES.lien : '';
  }

  function lienDans(brut) {
    var t = brut.replace(IGNORABLES, '');
    if (LIEN.test(t)) return true;
    var m;
    DOMAINE.lastIndex = 0;
    while ((m = DOMAINE.exec(t))) {
      if (SUFFIXES.has(m[1].toLowerCase())) return true;
      DOMAINE.lastIndex = m.index + (t.codePointAt(m.index) > 0xFFFF ? 2 : 1);
    }
    return false;
  }

  function fauteNom(brut, longueur) {
    var v = brut.replace(/\s+/g, ' ').trim().slice(0, longueur);
    if (NOM_CONTROLE.test(brut) || NOM_IGNORABLE.test(brut)) return MESSAGES.invisible;
    var nfc = typeof v.normalize === 'function' ? v.normalize('NFC') : v;
    var t = nfc.replace(/ {2,}/g, ' ').trim();
    if (POINT_HORS_ABREVIATION.test(pourLien(t))) return MESSAGES.lien;
    if (!t || Array.from(t).length > longueur || pourLien(nfc) !== nfc || !NOM.test(t)) return MESSAGES.nom;
    return '';
  }

  function pourLien(v) {
    var t = typeof v.normalize === 'function' ? v.normalize('NFKC') : v;
    return t.replace(POINTS, '.');
  }

  function autreArticle(panier) {
    var items = panier && Array.isArray(panier.items) ? panier.items : [];
    for (var i = 0; i < items.length; i++) {
      if (String(items[i].sku || '') !== 'ABO-VIEWS-MAGAZINE' && String(items[i].handle || '') !== 'abonnement') return true;
    }
    return false;
  }

  function lirePanier() {
    return new Promise(function (resolu) {
      var fini = false;
      function fin(panier) {
        if (fini) return;
        fini = true;
        resolu(panier);
      }
      window.setTimeout(function () { fin(null); }, LECTURE_MAX_MS);
      fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) {
        return r && r.ok ? r.json() : null;
      }).then(fin, function () { fin(null); });
    });
  }

  function jourParis(decalage) {
    var texte = new Intl.DateTimeFormat('fr-CA', { timeZone: 'Europe/Paris', year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date());
    var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(texte);
    if (!m) return '';
    var t = Date.UTC(Number(m[1]), Number(m[2]) - 1, Number(m[3]) + (decalage || 0), 12);
    return new Date(t).toISOString().slice(0, 10);
  }

  function jjmmaaaa(iso) {
    var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(iso || ''));
    return m ? m[3] + '/' + m[2] + '/' + m[1] : '';
  }

  function texte(el) {
    return el ? String(el.value || '').replace(/\s+/g, ' ').trim() : '';
  }

  function initialiser(form) {
    var caseCadeau = form.querySelector('[data-vw-abo-cadeau]');
    var message = form.querySelector('[data-vw-abo-message]');
    var boutons = form.querySelectorAll('button[type="submit"]');
    var email = form.querySelector('[data-vw-abo-email]');
    var quand = form.querySelector('[data-vw-abo-quand]');
    var champDate = form.querySelector('[data-vw-abo-date-champ]');
    var date = form.querySelector('[data-vw-abo-date]');
    var erreurDate = form.querySelector('[data-vw-abo-date-erreur]');
    var motCarte = form.querySelector('[data-vw-abo-message-carte]');
    var compte = form.querySelector('[data-vw-abo-compte]');
    var racine = typeof form.closest === 'function' ? form.closest('[data-vw-abonnement]') : null;
    var portee = racine || form;
    var visuels = racine ? racine.querySelectorAll('[data-vw-abo-visuel]') : [];
    var barre = portee.querySelector('[data-vw-abo-barre]');
    var cartes = form.querySelector('[data-vw-abo-cartes]');
    var envoi = false;
    var charge = Date.now();

    function modeCadeau() {
      return !!(caseCadeau && caseCadeau.checked);
    }

    function activer(bloc, actif) {
      var champs = bloc.querySelectorAll('input, textarea');
      for (var i = 0; i < champs.length; i++) champs[i].disabled = !actif;
    }

    function radioPour(k) {
      var mode = modeCadeau() ? 'cadeau' : 'perso';
      return form.querySelector('[data-vw-mode="' + mode + '"] input[name="vw-abo-formule"][data-k="' + k + '"]');
    }

    function majCartes() {
      var blocs = portee.querySelectorAll('[data-vw-abo-carte], [data-vw-abo-choisir]');
      for (var i = 0; i < blocs.length; i++) {
        var k = blocs[i].getAttribute('data-vw-abo-carte') || blocs[i].getAttribute('data-vw-abo-choisir');
        blocs[i].hidden = !radioPour(k);
      }
    }

    function choisir(bouton) {
      var radio = radioPour(bouton.getAttribute('data-vw-abo-choisir'));
      if (!radio) return;
      var radios = form.querySelectorAll('input[name="vw-abo-formule"]');
      for (var i = 0; i < radios.length; i++) radios[i].checked = radios[i] === radio;
      majK();
      majVisuel();
    }

    function formuleCochee() {
      var radios = form.querySelectorAll('input[name="vw-abo-formule"]');
      for (var i = 0; i < radios.length; i++) if (radios[i].checked && !radios[i].disabled) return radios[i];
      return null;
    }

    function majQuand() {
      if (!quand) return;
      var avecEmail = modeCadeau() && texte(email) !== '';
      quand.hidden = !avecEmail;
      activer(quand, avecEmail);
      var parDate = avecEmail && !!form.querySelector('input[name="vw-abo-quand"][value="date"]:checked');
      if (champDate) {
        champDate.hidden = !parDate;
        if (date) {
          date.disabled = !parDate;
          date.required = parDate;
          date.min = jourParis(1);
        }
      }
      if (erreurDate && !parDate) erreurDate.hidden = true;
    }

    function majK() {
      var radio = formuleCochee();
      var k = form.querySelector('[data-vw-abo-k]');
      if (k && radio) k.textContent = radio.getAttribute('data-k') || '';
    }

    function majVisuel() {
      if (visuels.length < 2) return;
      var radio = formuleCochee();
      var cible = radio && radio.getAttribute('data-k') === '8' ? '8' : '4';
      for (var i = 0; i < visuels.length; i++) visuels[i].hidden = visuels[i].getAttribute('data-vw-abo-visuel') !== cible;
    }

    function majMode() {
      var cadeau = modeCadeau();
      var blocs = portee.querySelectorAll('[data-vw-mode]');
      for (var i = 0; i < blocs.length; i++) {
        var visible = blocs[i].getAttribute('data-vw-mode') === (cadeau ? 'cadeau' : 'perso');
        blocs[i].hidden = !visible;
        if (blocs[i].tagName === 'LABEL' || blocs[i].tagName === 'DIV') activer(blocs[i], visible);
      }
      if (!formuleCochee()) {
        var premiere = form.querySelector('[data-vw-mode="' + (cadeau ? 'cadeau' : 'perso') + '"] input[name="vw-abo-formule"]');
        if (premiere) premiere.checked = true;
      }
      majCartes();
      majQuand();
      majK();
      majVisuel();
    }

    function majCompte() {
      if (compte && motCarte) compte.textContent = String(String(motCarte.value || '').length);
    }

    function dire(t) {
      if (message) message.textContent = t;
    }

    function occupe(oui) {
      envoi = oui;
      for (var i = 0; i < boutons.length; i++) {
        boutons[i].disabled = oui;
        boutons[i].setAttribute('aria-busy', oui ? 'true' : 'false');
      }
    }

    function proprietes() {
      var p = {
        _premier_numero: form.getAttribute('data-premier') || '',
        _parution: form.getAttribute('data-parution') || '',
        _premier_envoi: form.getAttribute('data-premier-envoi') || '',
        _premier_periode: form.getAttribute('data-premier-periode') || '',
        _abo_offre: form.getAttribute('data-offre') || ''
      };
      if (!modeCadeau()) return p;
      p['Cadeau pour'] = texte(form.querySelector('[data-vw-abo-pour]')).slice(0, 60);
      p['De la part de'] = texte(form.querySelector('[data-vw-abo-de]')).slice(0, 40);
      var mot = texte(form.querySelector('[data-vw-abo-message-carte]')).slice(0, 200);
      if (mot) p._message_carte = mot;
      var adresse = texte(email);
      if (adresse) {
        p['E-mail du destinataire'] = adresse;
        var parDate = !!form.querySelector('input[name="vw-abo-quand"][value="date"]:checked');
        p['Lui annoncer le'] = parDate && date ? jjmmaaaa(date.value) : 'juste après la commande';
      }
      return p;
    }

    function cadeauLisible() {
      if (!modeCadeau()) return true;
      for (var i = 0; i < CHAMPS_CADEAU.length; i++) {
        var el = form.querySelector(CHAMPS_CADEAU[i][0]);
        var v = el ? String(el.value || '') : '';
        var faute = fauteCadeau(v, CHAMPS_CADEAU[i][2]);
        if (faute) {
          dire(faute.replace('{champ}', CHAMPS_CADEAU[i][1]));
          if (el && typeof el.focus === 'function') el.focus();
          return false;
        }
      }
      return true;
    }

    function dateValide() {
      if (!date || date.disabled) return true;
      var v = String(date.value || '');
      var ok = /^\d{4}-\d{2}-\d{2}$/.test(v) && v >= jourParis(1) && (!date.max || v <= date.max);
      if (erreurDate) erreurDate.hidden = ok;
      return ok;
    }

    function nettoyerObligatoires() {
      var obligatoires = form.querySelectorAll('input[required]:not([disabled])');
      for (var i = 0; i < obligatoires.length; i++) {
        if (obligatoires[i].type === 'text' && texte(obligatoires[i]) === '') obligatoires[i].value = '';
      }
    }

    function ajouter(evenement) {
      evenement.preventDefault();
      if (envoi) return;
      dire('');
      nettoyerObligatoires();
      if (typeof form.reportValidity === 'function' && !form.reportValidity()) return;
      if (!cadeauLisible()) return;
      if (!dateValide()) return;
      var radio = formuleCochee();
      var variante = form.getAttribute('data-variante');
      if (!radio || !variante || !form.getAttribute('data-offre') || !form.getAttribute('data-premier')) {
        dire(MESSAGES.refus);
        return;
      }
      var reste = Number(form.getAttribute(modeCadeau() ? 'data-reste-cadeau' : 'data-reste'));
      if (!(reste > 0) || (Date.now() - charge) / 1000 >= reste) {
        occupe(true);
        dire(MESSAGES.refus);
        window.setTimeout(function () { window.location.reload(); }, 1500);
        return;
      }
      occupe(true);
      var corps = JSON.stringify({ items: [{ id: Number(variante), quantity: 1, selling_plan: Number(radio.getAttribute('data-plan')), properties: proprietes() }] });
      lirePanier().then(function (panier) {
        if (autreArticle(panier)) {
          occupe(false);
          dire(MESSAGES.seul);
          return null;
        }
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: corps
        });
      }).then(function (r) {
        if (r === null) return;
        if (r && r.ok) {
          dire(MESSAGES.succes);
          try { window.dispatchEvent(new CustomEvent('cart:updated')); } catch (e) {}
          window.setTimeout(function () { window.location.href = '/cart'; }, 300);
          return;
        }
        occupe(false);
        dire(r && r.status === 422 ? MESSAGES.refus : MESSAGES.echec);
      }, function () {
        occupe(false);
        dire(MESSAGES.echec);
      });
    }

    if (caseCadeau) caseCadeau.addEventListener('change', majMode);
    form.addEventListener('click', function (e) {
      var t = e.target && typeof e.target.closest === 'function' ? e.target.closest('[data-vw-abo-choisir]') : null;
      if (t) choisir(t);
    });
    form.addEventListener('keydown', function (e) {
      var t = e.target;
      if (e.key === 'Enter' && t && t.tagName === 'INPUT') e.preventDefault();
    });
    if (barre && cartes && typeof IntersectionObserver === 'function') {
      barre.hidden = true;
      new IntersectionObserver(function (entrees) {
        barre.hidden = entrees[entrees.length - 1].isIntersecting;
      }).observe(cartes);
    }
    form.addEventListener('change', function (e) {
      var t = e.target;
      if (!t) return;
      if (t.name === 'vw-abo-formule') {
        majK();
        majVisuel();
      }
      if (t.name === 'vw-abo-quand') majQuand();
      if (t.name === 'vw-abo-pour-qui') majMode();
    });
    if (email) email.addEventListener('input', majQuand);
    if (motCarte) motCarte.addEventListener('input', majCompte);
    if (date) date.addEventListener('change', dateValide);
    form.addEventListener('submit', ajouter);
    majMode();
  }

  function demarrer() {
    var forms = document.querySelectorAll('form[data-vw-abo-form]');
    for (var i = 0; i < forms.length; i++) initialiser(forms[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', demarrer);
  else demarrer();
})();
